/* eslint-disable max-lines */

import * as Form from '@cleartax/wg-library-form';
import { Input } from '@cleartax/wg-library-input';
import { Text } from '@cleartax/wg-library-typography';
import { useEffect } from 'react';

const form = [
  {
    type: <Input></Input>,
    validate: [Form.IsRequired],
    name: 'Your name',
    identifier: 'reviewerName',
    placeholder: 'Abhishek',
    width: 'w-ful',
  },
  {
    type: (
      <Input
        isTextArea={true}
        rows={4}
        cols={50}
        className="mt-1 px-3 py-2 bg-white border shadow-sm block w-full rounded-md sm:text-sm text-base focus:ring-1"
      ></Input>
    ),
    validate: [Form.IsRequired],
    name: 'Your review description',
    identifier: 'reviewText',
    placeholder: '',
    width: 'w-ful',
  },
];
export const ReviewForm = ({
  setFormValidity,
}: {
  setFormValidity: (
    isValid: boolean,
    value: Record<string, Form.TFormValue>
  ) => void;
}) => {
  const formCtx = Form.useFormContext();
  useEffect(() => {
    setFormValidity(formCtx.isFormValid, formCtx.formState.values);
  }, [formCtx.isFormValid]);
  return (
    <>
      <div className="">
        {form.map((ele, index) => {
          return (
            <Form.FormControl
              className={` pr-4 mb-6`}
              key={ele.name + index}
              name={ele.name}
            >
              <Text
                type="label"
                labelFor={ele.identifier}
                className="text-grey-800"
                weight="semibold"
                textSize="sm"
              >
                {ele.name}
              </Text>
              <Form.FormField
                validate={ele.validate}
                name={ele.name}
                id={ele.identifier}
              >
                {ele.type}
              </Form.FormField>
              <Form.ValidationMsg name={ele.name} id={ele.identifier} />
            </Form.FormControl>
          );
        })}
      </div>
    </>
  );
};
